import React from "react";
import { CallToActionRowWrapper } from "./CallToActionRow.styles";

const CallToActionRow = ({data}) => {

    const label = data.label;
    const tagLine = data.tag_line;
    const linkText = data.link_text;
    const linkUrl = data.link_url;

    return(
        <CallToActionRowWrapper id={data.row_id} className="flexipage-row bg-gradient-neutral" data-animation-trigger="true">
            <div className="flexipage-container" data-animation="animate__fadeIn" data-animation-duration="1s" data-animation-delay="0.1s">
                <h2>{label}:</h2>
                <div className="cta-content">
                    <div className="cta-tagline">
                        {tagLine}
                    </div>
                    <a href={linkUrl} className="button">{linkText}</a>    
                </div>
                
            </div>
        </CallToActionRowWrapper>
    )
}

export default CallToActionRow;